import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Table } from 'react-bootstrap';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { find as _find, findIndex as _findIndex } from 'lodash';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import WhiteLabelSystemMailData from 'components/layout/whiteLabel/WhiteLabelSystemMailData';

const systemMails = [
  {
    id: 'registration',
    descriptionKey: 'system_mail_registration_description',
    defaultContent: '',
    possibleSubstitutes: ['firstName', 'lastName'],
  },
  {
    id: 'invitation',
    descriptionKey: 'system_mail_invitation_description',
    defaultContent: '',
    possibleSubstitutes: ['company', 'firstName', 'lastName'],
  },
  {
    id: 'car_rental_pickup_reminder',
    descriptionKey: 'system_mail_car_rental_pickup_reminder_description',
    defaultContent: '',
    possibleSubstitutes: ['firstName', 'lastName'],
  },
  {
    id: 'car_rental_dropoff_reminder',
    descriptionKey: 'system_mail_car_rental_dropoff_reminder_description',
    defaultContent: '',
    possibleSubstitutes: ['firstName', 'lastName'],
  },
];

class WhiteLabelSystemMails extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      shownId: null,
    };
  }

  isCustomised = systemMailId => {
    const { appIntl, entity } = this.props;
    const systemMailData = _find(entity.getSystemMails(), ['id', systemMailId]);

    if (systemMailData) {
      const langContent = _find(systemMailData.content, ['lang', appIntl.displayIntlForm]);
      return !!(langContent && langContent.description);
    }

    return false;
  };

  handleClick = systemMailId => {
    const { entity, changeEntity } = this.props;
    this.setState(prevState => ({ shownId: systemMailId === prevState.shownId ? null : systemMailId }));

    const data = _find(entity.getSystemMails(), ['id', systemMailId]);
    if (!data) {
      // the entity does not have the data yet
      // we need to add the system mail definition
      let newSystemMail = entity.createValue('systemMails', [], { id: systemMailId });
      let newValue = entity.getSystemMails().slice();
      newValue.push(newSystemMail);
      let newEntity = { ...entity.updateValue('systemMails', newValue, []) };

      changeEntity(newEntity);
    }
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
    } = this.props;
    const { shownId } = this.state;

    const columns = ['ID', messages.description, messages.status];
    let tBody = [];
    if (entityLoaded) {
      tBody = systemMails.map((systemMail, i) => {
        const { id, descriptionKey } = systemMail;

        return (
          <tr
            key={id}
            class={(id === shownId ? 'shown ' : '') + (i % 2 ? 'even ' : 'odd ')}
            onClick={() => {
              this.handleClick(id);
            }}
          >
            <td class="v-align-middle semi-bold">{id}</td>
            <td class="v-align-middle">{messages[descriptionKey]}</td>
            <td class="v-align-middle text-right">{this.isCustomised(systemMail.id) ? 'custom' : 'generic'}</td>
          </tr>
        );
      });
    }

    if (shownId !== null) {
      const systemMailIndex = _findIndex(systemMails, ['id', shownId]);
      const systemMail = _find(systemMails, ['id', shownId]);
      const dataIndex = _findIndex(entity.getSystemMails(), ['id', shownId]);
      const data = _find(entity.getSystemMails(), ['id', shownId]);

      // user wants to see a email content form
      if (data) {
        tBody.splice(
          systemMailIndex + 1,
          0,
          <WhiteLabelSystemMailData
            key={'details-showing-' + shownId}
            entityLoaded={entityLoaded}
            entity={entity}
            changeEntity={this.props.changeEntity}
            disabled={disabled}
            systemMail={systemMail}
            data={data}
            colSpan={columns.length}
            dataIndex={dataIndex}
            project={entity}
          />
        );
      }
    }

    return (
      <div class="clearfix padding-20 sm-padding-10">
        {entityLoaded ? (
          <Table responsive hover class="table-detailed">
            <thead>
              <tr>

                {columns.map((column, i) => {
                  return (
                    <th key={i} class={column === messages.actions ? 'text-right' : ''}>
                      {column}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <ReactCSSTransitionGroup
              transitionName="tablerows"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={1}
              component="tbody"
            >
              {tBody}
            </ReactCSSTransitionGroup>
          </Table>
        ) : null}
      </div>
    );
  }
}
WhiteLabelSystemMails.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(WhiteLabelSystemMails));
